var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AbstractNotification',_vm._g(_vm._b({attrs:{"icon":"mdi-alert-circle-outline","color":"#F44336"}},'AbstractNotification',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }